module.exports = __webpack_public_path__ + "img/workshop-detail-banner-1900X800.45409c29.png";